import { Button, Flex, Input, Text } from '../../../../Components'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

export const ImportTutorial = () => (
  <Flex>
    <Text value={t.admTutorialUpload} size={16} style={{ marginTop: 20 }} />
    <Text value={t.admTutorialStruttura} size={16} />
    <Text value={t.admTutorialIntestazione} size={16} />
    <Text value={t.admTutorialDati} size={16} />
    <Flex row>
      <Text value={t.admTutorialEsempio} size={16} />
      <Button
        style={{ marginLeft: 10 }}
        label={t.admScarica}
        icon="download"
        onClick={() => window.location.assign('https://siap.cloud/Esempio%20Viaggiatori.csv')}
      />
    </Flex>
  </Flex>
)

export const TextEditor = ({ value, editorCallback }, isNumber) => (
  <Input
    id="txt"
    value={value}
    onChange={({ txt }) => {
      if (isNumber && /[a-zA-Z]/.test(txt)) {
        return
      }
      editorCallback(txt)
    }}
  />
)
